import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=7d6f4d9a&scoped=true&"
import script from "./WorkflowCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=7d6f4d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f4d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
